import BasicMarker from './BasicMarker';
export default BasicMarker;
